import reduceReducers from 'reduce-reducers';

//Siblings reducers
import fittestBookingReducer from './fittest-booking-reducer';

export default reduceReducers(fittestBookingReducer);
